/**
 *  @class
 *  @function CollectionTabs2
 */

if (!customElements.get('collection-tabs2')) {
  class CollectionTabs2 extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.flkty = null;
    }

    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return;

        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        // Tab buttons
        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        // CRITICAL: Ensure product links work by bypassing Flickity
        this.ensureProductLinksWork();
        
        // CRITICAL: Add global click handler for product links as backup
        this.addGlobalProductLinkHandler();

        // Initialize Flickity and progress bar
        this.initializeFlickity();

        // Resize handler
        window.addEventListener('resize', () => {
          if (this.flkty) {
            this.flkty.resize();
          }
        });

        // Design mode
        if (window.Shopify && Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    ensureProductLinksWork() {
      if (!this.slider) return;
      
      // Find all product links in the slider
      const productLinks = this.slider.querySelectorAll('a[href*="/products/"]');
      
      productLinks.forEach(link => {
        // Remove any existing click handlers that might interfere
        link.removeEventListener('click', this.handleProductLinkClick);
        
        // Add our own click handler that bypasses Flickity
        this.handleProductLinkClick = (event) => {
          // Stop event propagation to prevent Flickity from handling it
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Get the href and navigate manually
          const href = link.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        };
        
        link.addEventListener('click', this.handleProductLinkClick, true); // Use capture phase
        
        // Set appropriate z-index based on link type
        if (link.classList.contains('product-card--featured-image-link')) {
          link.style.zIndex = '10';
        } else if (link.classList.contains('product-card-title')) {
          link.style.zIndex = '10';
        } else {
          link.style.zIndex = '10';
        }
        
        link.style.pointerEvents = 'auto';
        link.style.position = 'relative';
        link.style.cursor = 'pointer';
        
        // Make sure parent elements don't block clicks
        const productCard = link.closest('.product-card');
        if (productCard) {
          productCard.style.pointerEvents = 'auto';
        }
        
        const column = link.closest('.columns');
        if (column) {
          column.style.pointerEvents = 'auto';
        }
      });
    }

    addGlobalProductLinkHandler() {
      // Add a global click handler that catches all product link clicks
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="/products/"]');
        if (link && this.slider && this.slider.contains(link)) {
          // This is a product link in our collection tabs 2 section
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          const href = link.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        }
      }, true); // Use capture phase to catch before Flickity
    }

    initializeFlickity() {
      if (!this.slider) return;

      // Get Flickity instance
      this.flkty = window.Flickity ? Flickity.data(this.slider) : null;
      
      if (this.flkty) {
        this.flkty.on('ready', () => {
          // Re-ensure product links work after Flickity is ready
          setTimeout(() => this.ensureProductLinksWork(), 200);
        });

        // Product link clicks are handled by ensureProductLinksWork() via capture-phase listeners.
        // Dragging/swiping is left enabled for mobile touch navigation.
        // Progress bar is handled natively by slideshow.js via Flickity's on.scroll event.
        this.updateArrowVisibility();
      }
    }

    updateArrowVisibility() {
      if (!this.slider) return;
      // Count products within active carousel slides
      const productCount = this.slider.querySelectorAll('.carousel__slide .product-card').length;
      
      if (productCount < 3) {
        this.slider.classList.add('hide-arrows');
      } else {
        this.slider.classList.remove('hide-arrows');
      }
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links && links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      if (!this.slider || !this.flkty) return;

      const products = this.slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const activeProducts = this.slider.querySelectorAll(`[data-collection="${handle}"]`);

      products.forEach((product) => { 
        product.classList.remove('carousel__slide'); 
        this.slider.append(product); 
      });
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      this.flkty.insert(activeProducts);
      this.flkty.reloadCells();
      this.flkty.select(0, false, true);
      
      // CRITICAL: Re-ensure product links work after collection change
      setTimeout(() => {
        this.ensureProductLinksWork();
        this.updateArrowVisibility();
      }, 100);
    }
  }

  customElements.define('collection-tabs2', CollectionTabs2);
}